module.exports = __webpack_public_path__ + "static/media/emo1.9e5bf72a.svg";